<template>
  <VAppBar
    app
    flat
    fixed
    align-center
    color="#fff"
    height="70px"
    id="report-top-menu"
    class="px-5"
    style="top: 56px; border-top: 1px solid #0000001A; box-shadow: 0px 5px 25px 0px #0000000D !important;"
  >
    <VSkeletonLoader
      fluid
      type="table-heading"
      :loading="!details"
      :class="{
        'd-flex align-center': details,
      }"
    >
      <VAppBarTitle 
        v-if="details"
        class="font-weight-bold ml-n4" 
        style="font-size: 18px;"
      >
        <VBtn 
          icon
          @click="onGoBack"
        >
          <VIcon 
            color="black"
            class="pr-1"
          >
            mdi-arrow-left
          </VIcon>
        </VBtn>
        Reporting / {{ featureName(details.modelType, 'capitalize') }} / {{ details.model.title }}
      </VAppBarTitle>
      <VSpacer />
      <VMenu
        bottom
        right
        offset-y
        close-on-content-click
      >
        <template #activator="{ on, attrs }">
          <VBtn
            v-bind="attrs"
            v-on="on"
            color="#0A5894"
            height="50px"
            class="white--text"
          >
            <VIcon>mdi-calendar</VIcon>
            <span 
              class="font-weight-medium pl-1"
              style="font-size: 15px;"
            >
              Date Range ({{ filterByDateRange == 'all' ? 'All Time' : `${filterByDateRange} Days` }})
            </span>
          </VBtn>
        </template>
        <VList style="border-radius: 10px;">
          <VRadioGroup
            hide-details
            class="ma-0"
            :value="filterByDateRange"
          >
            <VListItem
              link
              class="px-2"
              @click="filterByDateRange = 'all'"
            >
              <VListItemTitle class="d-flex align-center">
                <VRadio
                  color="success"
                  class="custom-radio mx-1 mb-1"
                  value="all"
                />
                <span
                  class="font-weight-medium"
                  style="font-size: 14px;"
                >
                  All Time
                </span>
              </VListItemTitle>
            </VListItem>
            <VListItem
              v-for="(range, index) in dateRange"
              link
              class="px-2"
              :key="index"
              @click="filterByDateRange = range.value"
            >
              <VListItemTitle class="d-flex align-center">
                <VRadio
                  color="success"
                  class="custom-radio mx-1 mb-1"
                  :value="range.value"
                />
                <span
                  class="font-weight-medium"
                  style="font-size: 14px;"
                >
                  {{ range.title }}
                </span>
              </VListItemTitle>
            </VListItem>
          </VRadioGroup>
        </VList>
      </VMenu>
      <FilterButton 
        :selected-items="filterByPrograms"
        :items="details ? details.related_programs : []"
        :button-text="`${featureName('Program')} Associations`"
        :description="`Below is a list of all ${featureName('Program')} that this ${featureName('Deliverable', 'singularize')} is associated with. For ${featureName('Deliverable')} associated with multiple ${featureName('Program')}, you can use this filter to narrow the data in your report to specific ${featureName('Program')} only.`"
        @apply="onApplyFilter"
      />
    </VSkeletonLoader>
  </VAppBar>
</template>
<script>
import FilterButton from '../Data/FilterButton';
export default {
  name: 'ReportTopMenu',
  components: { FilterButton },
  data() {
    return {
      details: null,
      dialogs: {
        programsFilter: false,
      },
      filterByDateRange: 'all',
      filterByPrograms: [],
      dateRange: [
        { title: 'Last 7 Days', value: 7 },
        { title: 'Last 30 Days', value: 30 },
        { title: 'Last 90 Days', value: 90 },
      ],
    };
  },
  watch: {
    filterByDateRange(value) {
      this.$bus.$emit('filterReport', value, this.filterByPrograms);
    },
  },
  created() {
    this.$bus.$on("reportDetails", (data) => {
      this.details = data;
      if(this.$route.params.hasOwnProperty('programs')) {
        this.filterByPrograms = this.$route.params.programs;
      } else {
        this.filterByPrograms = data.related_programs.map((program) => program.id);
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("reportDetails");
  },
  methods: {
    onGoBack() {
      if(localStorage.getItem('previous-url') == this.$router.history.current.fullPath) {
        this.$router.push({
          name: `${this.details.modelType}.index`,
          params: {
            team: this.$team.slug,
          },
        });
      } else {
        this.$router.push(localStorage.getItem('previous-url'));
      }
    },
    onApplyFilter(value) {
      this.filterByPrograms = value;
      this.$bus.$emit('filterReport', this.filterByDateRange, value);
    },
  },
}
</script>
<style lang="scss">
#report-top-menu {
  .v-app-bar-title__content {
    width: 468px !important;
  }
}
</style>